import { writable } from 'svelte/store';

export const selectedMilestones = writable({});

export const searchDates = writable([]);
